import { Injectable, OnDestroy } from '@angular/core';
import { DelegatePersistLayoutService } from '@common-modules/dynamic-layout/delegate-persist-layout/delegate-persist-layout.service';
import { DynamicLayoutSettings } from '@common-modules/dynamic-layout/models/dynamic-layout-settings';
import { SetValueAction } from '@common-modules/dynamic-layout/state/generic/generic.actions';
import { GetValueSelector } from '@common-modules/dynamic-layout/state/generic/generic.selectors';
import { ReduxStateService } from '@common-modules/redux/redux-state.service';
import { Observable } from 'rxjs';

@Injectable()
export class DelegatePersistLayoutReduxService
  extends DelegatePersistLayoutService
  implements OnDestroy
{
  private _reduxStateService: ReduxStateService;
  private readonly _fieldNamePrefix = 'DelegatePersist';
  private _delegateIds = new Set<string>();

  config(data: { stateService: ReduxStateService }): void {
    this._reduxStateService = data.stateService;
  }

  private buildFieldName(delegateToId: string): string {
    return [this._fieldNamePrefix, delegateToId].join('#');
  }

  delegate(delegateToId: string, settings: DynamicLayoutSettings): void {
    this._delegateIds.add(delegateToId);
    this.sendAction(delegateToId, settings);
  }

  removeDelegated(delegateToId: string): void {
    this.sendAction(delegateToId, null);
  }

  getDelegated(delegateToId: string): Observable<DynamicLayoutSettings> {
    const fieldName = this.buildFieldName(delegateToId);

    const selector = new GetValueSelector({
      fieldName,
    });
    return this._reduxStateService.select<DynamicLayoutSettings>(selector);
  }

  private sendAction(delegateToId: string, settings?: DynamicLayoutSettings): void {
    const fieldName = this.buildFieldName(delegateToId);

    const action = new SetValueAction({
      fieldName,
      value: settings,
    });

    this._reduxStateService.dispatch(action);
  }

  ngOnDestroy(): void {
    // Cleanup all possible state remnants.
    this._delegateIds.forEach((id) => {
      this.removeDelegated(id);
    });
  }
}
